import React from 'react';
import { EventModel } from '../types/Event';
import { getPosterPathFromName, getPosterEmoji } from '../utils/assets';

interface EventImageProps {
  event: EventModel;
  size?: number;
  showBorder?: boolean;
  isCircular?: boolean;
  className?: string;
}

const EventImage: React.FC<EventImageProps> = ({ 
  event, 
  size = 60, 
  showBorder = true, 
  isCircular = true,
  className = ''
}) => {
  const getStatusFilter = () => {
    if (event.status === 'past' || event.status === 'canceled') {
      return 'grayscale(100%)';
    }
    return 'none';
  };

  const containerStyle: React.CSSProperties = {
    width: isCircular ? size : size * 0.8,
    height: isCircular ? size : size * 1.2,
    borderRadius: isCircular ? '50%' : '12px',
    border: showBorder ? '2px solid rgba(255, 255, 255, 0.3)' : 'none',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    filter: getStatusFilter(),
  };

  const imageStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  };

  const fallbackStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    background: 'linear-gradient(135deg, rgba(147, 51, 234, 0.8), rgba(59, 130, 246, 0.8))',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: size * 0.4,
    color: 'white',
  };

  if (event.imageName) {
    return (
      <div style={containerStyle} className={className}>
        <img
          src={getPosterPathFromName(event.imageName)}
          alt={`${event.name} poster`}
          style={imageStyle}
          onError={(e) => {
            // Fallback to emoji if image fails to load
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
            const parent = target.parentElement;
            if (parent && event.imageName) {
              parent.innerHTML = `<div style="${Object.entries(fallbackStyle).map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value}`).join('; ')}">${getPosterEmoji(event.imageName)}</div>`;
            }
          }}
        />
      </div>
    );
  }

  return (
    <div style={containerStyle} className={className}>
      <div style={fallbackStyle}>
        🎉
      </div>
    </div>
  );
};

export default EventImage;
